export default __webpack_public_path__ + "static/media/A-image.05d4e9bb.png";